import React from 'react';
import { FC } from 'react';
import { IconProps } from '@components/common/Icons/types';

export const BankStatementsIcon: FC<IconProps> = ({ width = '24', height = '24', className }) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
  >
    <path
      d='M14.75 11.75H14.76M4.75 4.75H16.75C17.2804 4.75 17.7891 4.96071 18.1642 5.33579C18.5393 5.71086 18.75 6.21957 18.75 6.75V16.75C18.75 17.2804 18.5393 17.7891 18.1642 18.1642C17.7891 18.5393 17.2804 18.75 16.75 18.75H2.75C2.21957 18.75 1.71086 18.5393 1.33579 18.1642C0.960714 17.7891 0.75 17.2804 0.75 16.75V2.75C0.75 2.21957 0.960714 1.71086 1.33579 1.33579C1.71086 0.960714 2.21957 0.75 2.75 0.75H16.75'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
